import { default as Component } from "./PersonalInformationForm";
import { default as container } from "./PersonalInformationFormContainer";

export const PersonalInformationForm = container(Component);
